import React from 'react';
import { string, bool, number, arrayOf, shape } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import GiftingHeader from '../GiftingHeader';
import GiftValuePanel from '../GiftValuePanel';
import FrequentlyAskedQuestions from '../FrequentlyAskedQuestions';
import OnePercentForThePlanet from '../OnePercentForThePlanet';
import GiveAllTrailsBanner from '../GiveAllTrailsBanner';

const GiftLandingPage = ({ currencyCode, planTypes, languageRegionCode }) => {
  const scrollToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <>
      <GiftingHeader currencyCode={currencyCode} planTypes={planTypes} />
      <GiftValuePanel />
      <FrequentlyAskedQuestions languageRegionCode={languageRegionCode} />
      <OnePercentForThePlanet />
      <GiveAllTrailsBanner handleClick={scrollToTop} />
      <div data-bg="https://cdn-assets.alltrails.com/assets/images/gifting/scenic-overlook@2x.png" className={`${styles.bannerImage} lazyload`} />
    </>
  );
};

GiftLandingPage.propTypes = {
  currencyCode: string,
  planTypes: arrayOf(
    shape({
      allowCoupon: bool,
      numberOfMonths: string,
      planCode: string,
      priceMonth: number,
      priceTotal: number,
      showDiscount: bool
    })
  ).isRequired
};

GiftLandingPage.defaultProps = {
  currencyCode: 'USD'
};

export default GiftLandingPage;
